import { Component, Vue } from 'vue-facing-decorator';
import { ElMessage, ElMessageBox, ElNotification } from 'element-plus';
import { Check, Delete, List, CirclePlusFilled, UserFilled, VideoPlay, RefreshLeft, Document, Close, List, Ticket, Warning, Right, CircleCheck, CircleClose, Lock, ChatLineRound } from '@element-plus/icons-vue';
import Header from '@/components/Header/Header.vue';
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs.vue';
import Navigation from '@/components/Navigation/Navigation.vue';
import NavigationIndex from "@/models/EnumNavigationIndex";
import Status from "@/models/EnumStatus";
import AuthService from '@/services/AuthService';
import ApiService from '@/services/ApiService';

@Component(
{
    components:
    {
        Header,
        Breadcrumbs,
        Navigation,
        List,
        UserFilled,
        CirclePlusFilled,
        Check,
        ChatLineRound,
        Delete,
        VideoPlay,
        Warning,
        RefreshLeft,
        Document,
        Close,
        List,
        Ticket,
        Right,
        CircleClose,
        CircleCheck,
        Lock
    },
    enums:
    {
        NavigationIndex,
        Status
    }
})

export default class TestEdit extends Vue 
{
    private activeName: string = "2";
    private testId : string = '';
    private clientId : string = '';
    private testName : string = '';
    private testDate : Date = new Date();
    private testModel : TestModel | undefined = {} as TestModel;
    private hasPermission: boolean[] = [] as boolean[];
    private participantModel : ParticipantModel = {} as ParticipantModel;
    private tokenLists : TokenListModel[] = [] as TokenListModel[];
    private clientList : ClientModel[] = [] as ClientModel[];
    private targetGroupList : TargetGroupModel[] = [] as TargetGroupModel[];
    private participantList : ParticipantModel[] = [] as ParticipantModel[];
    private tokenListId : string = "Bitte wählen...";
    private tokenId : string = "Bitte wählen...";
    private targetGroupId : string = "Bitte wählen...";
    private tokens : TokenModel[] = [] as TokenModel[];
    private loading : boolean = true;
    private loadingTest : boolean = true;
    private adding : boolean = false;
    private isCustomer : boolean = true;
    private downloadingXLS : boolean = false;
    private downloadingPDF : boolean = false;
    private downloadingQuestions : boolean = false;
    private downloadingSolutions : boolean = false;
    private downloadingEvaluation : boolean = false;
    private formValid : boolean = true;
    private formParticipantValid : boolean = false;
    private toDelete : ParticipantModel | undefined;
    private testComplexity : string [] = ['Single Choice', 'Multiple Choice'];
    private selectedComplexity : string = "";
    private selectedCount : number = 60;
    private ticketsToAdd : number = 0;
    private showCorrectCount : boolean = false;
    private windowWidth : number = window.innerWidth;
    private windowHeight : number = window.innerHeight;

    private rules =
    {
        name:
        [
            {
                required: true,
                message: "Bitte geben Sie eine Bezeichnung ein.",
                trigger: "blur"
            }
        ]
    };

    public async mounted()
    {
        // get permissions
        await AuthService.getPermissions();
        this.hasPermission['TEST_SELECT'] = AuthService.hasPermission('TEST_SELECT');
        this.hasPermission['TEST_INSERT'] = AuthService.hasPermission('TEST_INSERT');
        this.hasPermission['TEST_UPDATE'] = AuthService.hasPermission('TEST_UPDATE');
        this.hasPermission['TEST_DELETE'] = AuthService.hasPermission('TEST_DELETE');
        this.hasPermission['TEST_QUESTION'] = AuthService.hasPermission('TEST_QUESTION');
        this.hasPermission['TEST_EVAL'] = AuthService.hasPermission('TEST_EVAL');
        
        if (this.hasPermission['TEST_UPDATE'] || this.hasPermission['TEST_QUESTION'])
        {
            // check if user is a customer
            this.isCustomer = await AuthService.isCustomer();

            // get test id from get request
            this.testId = this.$route.params.testid as string;

            // load location from db
            this.testModel = await ApiService.getTest(this.testId);
            
            if (!this.testModel) 
            {
                this.$router.push('/test');
                return;
            }
            else
            {
                this.testName = this.testModel.name;
                this.testDate = new Date(0).setUTCSeconds(this.testModel.testdate);
                this.targetGroupId = this.testModel.targetgroupid;
                this.selectedComplexity = this.testComplexity[this.testModel.complexity];
                this.showCorrectCount = this.testModel.showcorrectcount;

                await this.loadTokenList();
                await this.loadClientList();
                await this.loadTargetGroups();
                await this.loadParticipants();
            }
        }

        //await this.loadParticipants();
        window.addEventListener('resize', this.onWindowResize);
        
        if (!this.hasPermission['TEST_UPDATE'] && this.hasPermission['TEST_QUESTION'])
        {
            this.activeName = "1";
        }

        this.loadingTest = false;
    }

    private beforeUnmount()
    {
        window.removeEventListener('resize', this.onWindowResize);
    }

	private onWindowResize(e : any)
    {
        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;
    }

    private async loadTokenList()
    {
        this.loading = true;
        this.tokenLists = await ApiService.getTokenListsForCustomer(this.testModel.customerid.toString()) as TokenListModel[];
        this.loading = false;
    }

    private async loadClientList()
    {
        this.loading = true;
        this.clientList = await ApiService.getClientListForCustomer(this.testModel.customerid.toString()) as ClientModel[];
        if (this.clientList.length > 0)
        {
            this.clientId = this.clientList[0].clientid;
        }
        this.loading = false;
    }

    private async loadParticipants()
    {
        this.loading = true;
        this.participantList = await ApiService.getParticipantsForTest(this.testModel.testid.toString()) as ParticipantModel[];
        this.loading = false;
    }

    private async loadTokens()
    {
        this.tokens = await ApiService.getAllUnusedTokensByTokenList(this.tokenListId) as TokenModel[];
    }

    private async loadTargetGroups()
    {
        this.loading = true;
        this.targetGroupList = await ApiService.getAllTargetGroups() as TargetGroupModel[];
        this.loading = false;
    }

    private async startTest()
    {
        if (this.testModel.statusid == Status.TEST_DRAFT)
        {
            this.testModel.statusid = Status.TEST_PENDING;
            this.testModel = await ApiService.updateTest(this.testModel);

            if (this.testModel.testid > 0)
            {
                this.$router.push(`/questionnaire/${this.testModel.testid}/1/1`);
            }
        }
        else if (this.testModel.statusid == Status.TEST_PENDING)
        {
            this.$router.push(`/questionnaire/${this.testModel.testid}/1/3`);
        }
        else if (this.testModel.statusid >= Status.TEST_START)
        {
            this.$router.push(`/questionnaire/${this.testModel.testid}/1/3`);
        }
    }

    private async resetTest()
    {
        if (!this.testModel) return;

        await ApiService.resetTest(this.testModel);

        this.$router.go();
    }

    private async saveTest()
    {
        // store selected date in test model, if set from date picker
        if (Object.prototype.toString.call(this.testDate) === "[object Date]")
        {
            this.testModel.testdate = ApiService.getTimestampForTimezone(this.testDate, "Europe/Berlin") as Date;
        }

        // make api call to update this test
        let ok : any = await ApiService.updateTest(this.testModel);

        if (ok)
        {
			ElMessage({message: "Änderungen wurden übernommen.",	type: 'success'});
        }
        else
        {
            // or show error message
			ElMessage({message: "Änderungen konnten nicht gespeichert werden.",	type: 'error'});
        }
    }
    
    private getTestResult()
    {
        if (this.participantList)
        {
            let total : number = 0;
            let passed : number = 0;

            for (let p of this.participantList)
            {
                if (p.datestart > 0 && p.datestop > 0) total++;
                if (p.haspassed) passed++;
            }

            return Math.round(passed / total * 100);
        }

        return 0;
    }

    private async createParticipant()
    {
        let participant : ParticipantModel = {} as ParticipantModel;

        participant.testid = this.testModel.testid;
        participant.tokenid = Number(this.tokenId);
        participant.targetgroupid = Number(this.targetGroupId);

        participant = await ApiService.createParticipant(participant);

        if (participant.participantid > 0)
        {
			ElMessage({message: "Prüfling wurde registriert.",	type: 'success'});
            this.activeName = "2";
            this.tokenId = null;
            await this.loadTokens();
            await this.loadParticipants();
        }
        else
        {
            // or show error message
			ElMessage({message: "Der Prüfling konnte nicht registriert werden.",	type: 'error'});
        }
    }

    private async createMultipleParticipants()
    {
        this.adding = true;
        
        let i : number = 0;

        for (i = 0; i < this.ticketsToAdd; i++)
        {
            let participant : ParticipantModel = {} as ParticipantModel;

            participant.testid = this.testModel.testid;
            participant.tokenid = this.tokens[0].tokenid;
            participant.targetgroupid = Number(this.targetGroupId);
            participant.clientid = Number(this.clientId);
            
            // store participant entry
            participant = await ApiService.createParticipant(participant);

            // update this participants token, if it was reused from another client
            await ApiService.updateParticipant(participant);
            
            // reload tokens, to get the next free one
            if (participant.participantid > 0)
            {
                await this.loadTokens();
            }
        }

        if (i >= this.ticketsToAdd)
        {
            let msg = `Es wurden ${i} neue Prüflinge erfoglreich registriert.`;

            if (i == 1)
            {
                msg = `Es wurde 1 neuer Prüfling erfoglreich registriert.`;
            }

            ElNotification(
            {
                title: 'OK',
                message: msg,
                type: 'success',
                offset: 15
            });
            this.activeName = "2";
            this.tokenId = null;
            await this.loadTokens();
            await this.loadParticipants();
        }
        else
        {
            // or show error message
            ElMessage({message: "Nicht alle Prüflinge konnten registriert werden.",	type: 'error'});
        }

        this.adding = false;
    }

    private async deleteParticipant(participant : ParticipantModel)
    {
        let ok = await ApiService.deleteParticipant(participant);

        if (ok)
        {
			ElMessage(
            {
               	message: "Prüfling wurde gelöscht.",
               	type: 'success',
            });
            await this.loadTokens();
            await this.loadParticipants();
        }
        else
        {
            // or show error message
			ElMessage(
            {
               	message: "Prüfling konnte nicht gelöscht werden.",
               	type: 'error',
            });
        }
    }

    private getTargetGroup(targetgroupid : string)
    {
        for (let group : TargetGroupModel of this.targetGroupList)
        {
            if (group.targetgroupid == targetgroupid) return group;
        }

        return null;
    }

    private validateForm() : boolean
    {
        if (!this.testModel || this.testModel!.name.length <= 0) return false;

        return true;
    }

    private validateParticipantForm() : boolean
    {
        if (isNaN(this.tokenListId) || isNaN(this.tokenId) || (isNaN(this.targetGroupId) && this.testModel.ismixed)) return false;

        return true;
    }

    private onInput()
    {
        this.formValid = this.validateForm();
        this.formParticipantValid = this.validateParticipantForm();
    }
    
    private async onTokenListSelect()
    {
        this.formParticipantValid = this.validateParticipantForm();
        await this.loadTokens();
    }

    private onSaveClick()
    {
        this.saveTest();
    }

    private onDeleteConfirm(action : string)
    {
        if (this.toDelete && action == 'confirm')
        {
            this.deleteParticipant(this.toDelete);
        }
    }

    private onResetConfirm(action : string)
    {
        if (action == 'confirm')
        {
            this.resetTest();
        }
    }

    private onAddParticipantClick()
    {
        if (!this.testModel.ismixed)
        {
            this.targetGroupId = this.testModel.targetgroupid;
        }

        this.createParticipant();
    }

    private onAddMultipleParticipantsClick()
    {
        if (!this.testModel.ismixed)
        {
            this.targetGroupId = this.testModel.targetgroupid;
        }

        this.createMultipleParticipants();
    }

    private onParticipantDeleteClick(participant : ParticipantModel)
    {
        this.toDelete = participant;

        ElMessageBox.confirm('Soll dieser Prüfling wirklich gelöscht werden?', 'Warning', 
        {
            type: 'warning',
            title: '',
            callback: this.onDeleteConfirm,
            confirmButtonText: 'Löschen',
            cancelButtonText: 'Abbrechen'
        });
    }

    private async onComplexityChange()
    {
        this.testModel.complexity = this.testComplexity.indexOf(this.selectedComplexity);

        let ok: boolean = await ApiService.updateTest(this.testModel);
        
        if (!ok)
        {
            ElNotification(
            {
                title: 'Fehler',
                message: 'Die Befragungsart konnte nicht gespeichert werden.',
                type: 'error',
                offset: 15
            });
        }
    }

    private async onCorrectShowChange()
    {
        this.testModel.showcorrectcount = this.showCorrectCount;
        let ok: boolean = await ApiService.updateTest(this.testModel);
        
        if (!ok)
        {
            ElNotification(
            {
                title: 'Fehler',
                message: 'Die Änderung konnte nicht gespeichert werden.',
                type: 'error',
                offset: 15
            });
        }
    }

    private async onQuestionCountChange()
    {
        // make sure, timelimit fits to selected count
        if (this.testModel.questioncount == 28)
        {
            this.testModel.timelimit = 60;
        }
        else if (this.testModel.questioncount == 60)
        {
            this.testModel.timelimit = 120;
        }

        // update testmodel 
        let ok: boolean = await ApiService.updateTest(this.testModel);
        
        // return error message, when updateing failed
        if (!ok)
        {
            ElNotification(
            {
                title: 'Fehler',
                message: 'Die Änderung konnte nicht gespeichert werden.',
                type: 'error',
                offset: 15
            });
        }
    }

    private async onTimelimitChange()
    {
        // make sure, timelimit fits to selected count
        if (this.testModel.timelimit == 60)
        {
            this.testModel.questioncount = 28;
        }
        else if (this.testModel.timelimit == 120)
        {
            this.testModel.questioncount = 60;
        }

        let ok: boolean = await ApiService.updateTest(this.testModel);
        
        if (!ok)
        {
            ElNotification(
            {
                title: 'Fehler',
                message: 'Die Änderung konnte nicht gespeichert werden.',
                type: 'error',
                offset: 15
            });
        }
    }

    private async onMixedChange()
    {
        let ok: boolean = await ApiService.updateTest(this.testModel);
        
        if (!ok)
        {
            ElNotification(
            {
                title: 'Fehler',
                message: 'Die Änderung konnte nicht gespeichert werden.',
                type: 'error',
                offset: 15
            });
        }
    }

    private async onSuccessPercentageChange()
    {
        let ok: boolean = await ApiService.updateTest(this.testModel);
        
        if (!ok)
        {
            ElNotification(
            {
                title: 'Fehler',
                message: 'Die Änderung konnte nicht gespeichert werden.',
                type: 'error',
                offset: 15
            });
        }
    }

    private onStartClick()
    {
		this.startTest();
    }

    private onResetClick()
    {
        ElMessageBox.confirm('Soll diese Prüfung wirklich zurückgesetzt werden?', 'Warning', 
        {
            type: 'warning',
            title: '',
            callback: this.onResetConfirm,
            confirmButtonText: 'Zurücksetzen',
            cancelButtonText: 'Abbrechen'
        });
    }

    private onEditClick()
    {
        this.$router.push(`/questionnaire/${this.testModel.testid}/edit`);
    }

    private onAppealClick()
    {
        this.$router.push(`/questionnaire/${this.testModel.testid}/appeal`);
    }

    private async onDownloadClick()
    {
        this.downloadingXLS = true;

		let data : Blob | undefined = await ApiService.downloadParticipantList(this.testModel.testid.toString());

		if (data)
        {
            let blob : Blob = new Blob([data], {type: 'application/vnd.ms-excel'});
            let fileURL : string = window.URL.createObjectURL(blob);
            let fileLink : HTMLAnchorElement = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.download = 'Teilnehmerliste.xlsx';
            document.body.appendChild(fileLink);

            fileLink.click();

            URL.revokeObjectURL(fileLink.href);
        }
		else
		{
            ElNotification(
            {
                title: 'Fehler',
                message: 'Die Liste konnte nicht heruntergeladen werden.',
                type: 'error',
                offset: 10
            });
		}

        this.downloadingXLS = false;
    }

    private async onDownloadPDFClick(participant : ParticipantModel)
    {
        this.downloadingPDF = true;

		let data : Blob | undefined = await ApiService.downloadParticipantResult(participant.participantid.toString());

		if (data)
        {
            let blob : Blob = new Blob([data], {type: 'application/pdf'});
            let fileURL : string = window.URL.createObjectURL(blob);
            let fileLink : HTMLAnchorElement = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.download = `Prüfungsergebnis-${participant.participantid}-${participant.tokenid}.pdf`;
            document.body.appendChild(fileLink);

            fileLink.click();

            URL.revokeObjectURL(fileLink.href);
        }
		else
		{
            ElNotification(
            {
                title: 'Fehler',
                message: 'Die PDF-Datei konnte nicht heruntergeladen werden.',
                type: 'error',
                offset: 10
            });
		}

        this.downloadingPDF = false;
    }

    private async onDownloadQuestionsClick(participant : ParticipantModel)
    {
        this.downloadingPDF = true;

		let data : Blob | undefined = await ApiService.downloadParticipantQuestions(participant.participantid.toString());

		if (data)
        {
            let blob : Blob = new Blob([data], {type: 'application/pdf'});
            let fileURL : string = window.URL.createObjectURL(blob);
            let fileLink : HTMLAnchorElement = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.download = `Fragenliste-${participant.participantid}.pdf`;
            document.body.appendChild(fileLink);

            fileLink.click();

            URL.revokeObjectURL(fileLink.href);
        }
		else
		{
            ElNotification(
            {
                title: 'Fehler',
                message: 'Die PDF-Datei konnte nicht heruntergeladen werden.',
                type: 'error',
                offset: 10
            });
		}

        this.downloadingPDF = false;
    }

    private async onDownloadEvaluationClick()
    {
        this.downloadingEvaluation = true;

		let data : Blob | undefined = await ApiService.downloadEvaluation(this.testModel.testid.toString());

		if (data)
        {
            let blob : Blob = new Blob([data], {type: 'application/pdf'});
            let fileURL : string = window.URL.createObjectURL(blob);
            let fileLink : HTMLAnchorElement = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.download = `Auswertung-${this.testModel.testid}.pdf`;
            document.body.appendChild(fileLink);

            fileLink.click();

            URL.revokeObjectURL(fileLink.href);
        }
		else
		{
            ElNotification(
            {
                title: 'Fehler',
                message: 'Die PDF-Datei konnte nicht heruntergeladen werden.',
                type: 'error',
                offset: 10
            });
		}

        this.downloadingEvaluation = false;
    }

    private async onApproveParticipantClick(participant : ParticipantModel)
    {
        participant.isapproved = !participant.isapproved;
        await ApiService.approveParticipant(participant);
    }

    private async onDownloadQuestionListClick(test : TestModel)
    {
        this.downloadingQuestions = true;

		let data : Blob | undefined = await ApiService.downloadTestQuestions(test.testid.toString());

		if (data)
        {
            let blob : Blob = new Blob([data], {type: 'application/pdf'});
            let fileURL : string = window.URL.createObjectURL(blob);
            let fileLink : HTMLAnchorElement = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.download = `Fragebogen-${test.testid}.pdf`;
            document.body.appendChild(fileLink);

            fileLink.click();

            URL.revokeObjectURL(fileLink.href);
        }
		else
		{
            ElNotification(
            {
                title: 'Fehler',
                message: 'Die PDF-Datei konnte nicht heruntergeladen werden.',
                type: 'error',
                offset: 10
            });
		}

        this.downloadingQuestions = false;
    }

    private async onDownloadQuestionSolutionClick(test : TestModel)
    {
        this.downloadingSolutions = true;

		let data : Blob | undefined = await ApiService.downloadTestSolutions(test.testid.toString());

		if (data)
        {
            let blob : Blob = new Blob([data], {type: 'application/pdf'});
            let fileURL : string = window.URL.createObjectURL(blob);
            let fileLink : HTMLAnchorElement = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.download = `Lösungsschablone-${test.testid}.pdf`;
            document.body.appendChild(fileLink);

            fileLink.click();

            URL.revokeObjectURL(fileLink.href);
        }
		else
		{
            ElNotification(
            {
                title: 'Fehler',
                message: 'Die PDF-Datei konnte nicht heruntergeladen werden.',
                type: 'error',
                offset: 10
            });
		}

        this.downloadingSolutions = false;
    }

    private async onClientChange(participant : ParticipantModel)
    {
        await ApiService.updateParticipant(participant);
        await this.loadParticipants();
    }
}
